import * as actionTypes from '../constants/actionTypes';
export function externalPrototypeLoading() {
    return {
        type: actionTypes.EXTERNAL_PROTOTYPE_LOADING,
    };
}
export function externalPrototypeLoaded() {
    return {
        type: actionTypes.EXTERNAL_PROTOTYPE_LOADED,
    };
}
